var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificatesBarcodesAtaCarnets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 74 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 47.3332V0.666504H7.41658V47.3332H0.333252ZM10.3333 47.3332V0.666504H16.9999V47.3332H10.3333ZM20.3333 47.3332V0.666504H23.6666V47.3332H20.3333ZM30.3333 47.3332V0.666504H36.9999V47.3332H30.3333ZM40.3332 47.3332V0.666504H50.3332V47.3332H40.3332ZM53.6666 47.3332V0.666504H56.9999V47.3332H53.6666ZM63.6666 47.3332V0.666504H73.6666V47.3332H63.6666Z",
    fill: "#708130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificatesBarcodesAtaCarnets);
export default __webpack_public_path__ + "static/media/certificates_barcodes_ATA-carnets.0566781816a145ec4ca75578a634a5a7.svg";
export { ForwardRef as ReactComponent };